import { render, staticRenderFns } from "./TransactionUnpaid.vue?vue&type=template&id=64b77518&"
import script from "./TransactionUnpaid.vue?vue&type=script&lang=js&"
export * from "./TransactionUnpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports